import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'
import { clearUserInfo, getUserInfo } from './login'
let userInfo = null

const http = (params) => {
    const { method, postType, path, data, isCatch, loading } = params
    return new Promise((resolve, reject) => {
        if (!userInfo) {
            userInfo = getUserInfo()
        }
        const headers = {
            module: 'nuwa',
            channel: 'h5',
            ['content-Type']: 'application/json',
        }
        if (userInfo) {
            headers['token'] = userInfo.token
        }
        if (postType === 'form') {
            headers['content-Type'] = 'application/x-www-form-urlencoded'
        }

        if (loading.status) {
            Toast.loading({
                duration: 0,
                message: loading.text || 'Loading',
            })
        }
        axios({
            method,
            url: window.SEVER_DEFAULT_PATH + path,
            headers: headers,
            data,
            withCredentials: true,
        })
            .then((res) => {
                if (loading.status) Toast.clear()
                if (res.status == 200 && res.data.code === 200) {
                    resolve(res.data)
                } else if (res.data.code === 401) {
                    clearUserInfo()
                    window.location.reload()
                } else {
                    if (isCatch) {
                        reject(res)
                    }
                    Toast(res.data.message)
                }
            })
            .catch((err) => {
                if (loading.status) Toast.clear()
                if (isCatch) {
                    reject(err)
                }
                Toast(JSON.stringify(err))
            })
    })
}

export const h5_nuwa_post = (params) => {
    const { path, data, isCatch, loading = { status: true, text: '' } } = params
    return http({ channel: 'h5', method: 'POST', postType: '', path: '/nuwa-api' + path, data, isCatch, loading })
}

export const h5_nuwa_post_form = (params) => {
    const { path, data, isCatch, loading = { status: true, text: '' } } = params
    return http({
        channel: 'h5',
        method: 'POST',
        postType: 'form',
        path: '/nuwa-api' + path,
        data: qs.stringify(data),
        isCatch,
        loading,
    })
}

export const nuwa_post = (params) => {
    const { path, data, isCatch, loading = { status: true, text: '' } } = params
    return http({ method: 'POST', postType: '', path: '/nuwa-api' + path, data, isCatch, loading })
}

export const nuwa_post_form = (params) => {
    const { path, data, isCatch, loading = { status: true, text: '' } } = params
    return http({
        method: 'POST',
        postType: 'form',
        path: '/nuwa-api' + path,
        data: qs.stringify(data),
        isCatch,
        loading,
    })
}

export const begonia_post = (params) => {
    const { path, data, isCatch, loading = { status: true, text: '' } } = params
    return http({ method: 'POST', postType: '', path: '/begonia-api' + path, data, isCatch, loading })
}

export const begonia_post_form = (params) => {
    const { path, data, isCatch, loading = { status: true, text: '' } } = params
    return http({
        method: 'POST',
        postType: 'form',
        path: '/begonia-api' + path,
        data: qs.stringify(data),
        isCatch,
        loading,
    })
}

export const cupid_post_form = (params) => {
    const { path, data, isCatch, loading = { status: true, text: '' } } = params
    return http({
        method: 'POST',
        postType: 'form',
        path: '/cupid-api' + path,
        data: qs.stringify(data),
        isCatch,
        loading,
    })
}

// Ticket 登录
export const loginByAuthTicket = function (data) {
    return begonia_post_form({ path: '/user/loginByAuthTicket', data })
}
export const getWordHandout = (data) => {
    return nuwa_post_form({ path: '/app/pangu/wordHandout', data })
}

export const getSubjectTags = (data) => {
    return nuwa_post({ path: '/questionPaper/subjectTags', data })
}

export const getAllTags = (data) => {
    return nuwa_post({ path: '/questionPaper/tags', data })
}

export const getPaperList = (data) => {
    return nuwa_post({ path: '/questionPaper/list', data })
}
export const getPaperInfo = (data) => {
    return nuwa_post_form({ path: '/questionPaper/get', data })
}
export const getPaperBlockQuestions = (data) => {
    return nuwa_post_form({ path: '/questionPaper/getPaperBlockQuestions', data })
}

export const getLastCommitSummary = (data) => {
    return nuwa_post_form({ path: '/questionPaper/lastCommitSummary', data })
}

export const commitAnswer = (data) => {
    let url = `/questionPaper/commitAnswer?userId=${data.userId}&paperNo=${data.paperNo}`
    return nuwa_post({ path: url, data: data.userAnswerList })
}

export const getAnalysis = (data) => {
    return nuwa_post_form({ path: '/questionPaper/getAnalysis', data })
}

export const getLastCommitAnswer = (data) => {
    return nuwa_post_form({ path: '/questionPaper/getLastCommitAnswer', data })
}

export const putCollection = (data) => {
    return nuwa_post({ path: '/questionPaper/collection/put', data })
}

export const getCollectionList = (data) => {
    return nuwa_post({ path: '/questionPaper/collection/list', data })
}

export const delCollection = (data) => {
    return nuwa_post({ path: '/questionPaper/collection/del', data, loading: { status: data.loading || false } })
}

export const getCollectionQuestions = (data) => {
    return nuwa_post({ path: '/questionPaper/collection/questions', data })
}

export const getPaperStashState = (data) => {
    return nuwa_post({ path: '/questionPaper/stash/last', data })
}

export const updatePaperStashAnswer = (data) => {
    return nuwa_post({ path: '/questionPaper/stash/answer', data, loading: { status: false } })
}

export const commitPaperStashAnswer = (data) => {
    return nuwa_post({ path: '/questionPaper/stash/commit', data, loading: { status: false } })
}
